import type { CreateTrainingInput, UpdateTrainingInput } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

interface TrainingFilters {
  trainingType?: string
  category?: string
  isPublished?: string
  search?: string
  page?: string
  limit?: string
}

export function useTrainings(filters?: TrainingFilters) {
  return useQuery({
    queryKey: ['trainings', filters],
    queryFn: () => api.get('/api/trainings', filters),
  })
}

export function useTraining(id: string) {
  return useQuery({
    queryKey: ['trainings', id],
    queryFn: () => api.get(`/api/trainings/${id}`),
    enabled: !!id,
  })
}

export function useCreateTraining() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateTrainingInput & { schedules?: unknown[] }) =>
      api.post('/api/trainings', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['trainings'] }),
  })
}

export function useUpdateTraining() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateTrainingInput }) =>
      api.put(`/api/trainings/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['trainings'] }),
  })
}

export function useDeleteTraining() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.delete(`/api/trainings/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['trainings'] }),
  })
}
